/**
 * @file IconStop Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-stop',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.5}"
  >
    <rect width="48" height="48" x="0" y="0" />
    <g fill="#FC1212" fill-rule="nonzero" transform="translate(6,6)">
      <path
        d="M18 0C27.94113 0 36 8.05887 36 18 36 27.94113 27.94113 36 18 36 8.05887 36 0 27.94113 0 18 0 8.05887 8.05887 0 18 0ZM18 2C9.16344 2 2 9.16344 2 18 2 26.83656 9.16344 34 18 34 26.83656 34 34 26.83656 34 18 34 9.16344 26.83656 2 18 2ZM22 12C23.10457 12 24 12.89543 24 14L24 22C24 23.10457 23.10457 24 22 24L14 24C12.89543 24 12 23.10457 12 22L12 14C12 12.89543 12.89543 12 14 12L22 12Z"
      />
    </g>
  </g>
</svg>
`
);
